import Model from "./base/model";

class VehicleType extends Model {
  resourceName() {
    return "vehicle_types";
  }

  fields() {
    return {
      vehicle_type: "",
      vehicle_modal: "",
      vehicle_options: {jsonApi: "hasMany", type: "vehicle_options"},
      vehicle_option: {jsonApi: "hasMany", type: "vehicle_options"},
      vehicle_type_modal: {jsonApi: "hasMany", type: "vehicle_type_modal"},
    };
  }
}

export default new VehicleType();
